@if (isPreviewMode) {
  <div class="preview-ribbon">
    <tidy-text [helper]="'Preview data'" />
    <tidy-text [actionBody]="'Exit'" (action)="exitPreview()" class="link" />
  </div>
}
